(function () {
  if (window.__seedDiscountLoaded) return;
  window.__seedDiscountLoaded = true;

  const PRODUCT_ROOT_SELECTOR = "product-info[id^='MainProduct']";
  const PRODUCT_FORM_SELECTOR = 'form[data-seed-discount-product-form][data-type="add-to-cart-form"], product-form[data-seed-discount-product-form] form[data-type="add-to-cart-form"]';
  const MANAGED_INPUT_SELECTOR = 'input[name="discount"][data-seed-discount-input]';

  function getThemeDiscountCode(source) {
    return String(
      source?.dataset?.seedProductDiscountCode ||
        source?.querySelector?.('input[name="discount"]')?.value ||
        document.documentElement.dataset.seedDiscountCode ||
        ''
    ).trim();
  }

  function buildDiscountCheckoutUrl(code) {
    return `/discount/${encodeURIComponent(code)}?redirect=/checkout`;
  }

  function syncProductForms(scope = document) {
    const forms = Array.from(scope.querySelectorAll(PRODUCT_FORM_SELECTOR));

    forms.forEach((form) => {
      const code = getThemeDiscountCode(form);
      let input = form.querySelector(MANAGED_INPUT_SELECTOR) || form.querySelector('input[name="discount"]');

      if (!code) {
        if (input?.matches(MANAGED_INPUT_SELECTOR)) input.remove();
        return;
      }

      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'discount';
        input.dataset.seedDiscountInput = '';
        form.append(input);
      }

      input.value = code;
    });
  }

  function getDynamicCheckoutButton(event, root) {
    const targetButton = event.target?.closest?.('.shopify-payment-button__button--unbranded');
    if (targetButton && root.contains(targetButton)) return targetButton;

    const path = typeof event.composedPath === 'function' ? event.composedPath() : [];
    return (
      path.find(
        (node) =>
          node instanceof Element &&
          root.contains(node) &&
          node.matches('.shopify-payment-button__button--unbranded')
      ) || null
    );
  }

  function getCartAddFormData(form, code) {
    if (!(form instanceof HTMLFormElement) || !code) return null;

    const formData = new FormData(form);
    const variantId = String(formData.get('id') || '').trim();
    if (!/^\d+$/.test(variantId)) return null;

    formData.delete('discount');
    if (!formData.get('quantity')) formData.set('quantity', '1');
    return formData;
  }

  function addProductToCart(formData) {
    const config =
      typeof fetchConfig === 'function'
        ? fetchConfig('javascript')
        : { method: 'POST', headers: { Accept: 'application/javascript' } };
    config.headers = config.headers || {};
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = formData;

    return fetch(window.routes?.cart_add_url || '/cart/add', config).then(async (response) => {
      const result = await response.json();
      if (!response.ok || result.status) {
        throw new Error(result.description || result.message || window.cartStrings?.error || '');
      }
      return result;
    });
  }

  function showProductFormError(form, error) {
    const productForm = form?.closest('product-form');
    if (typeof productForm?.handleErrorMessage === 'function') {
      productForm.handleErrorMessage(error?.message || window.cartStrings?.error || '');
    }
  }

  function bindDynamicCheckout(root) {
    if (root.dataset.seedDiscountDynamicCheckoutBound === 'true') return;
    root.dataset.seedDiscountDynamicCheckoutBound = 'true';

    root.addEventListener(
      'click',
      async (event) => {
        const button = getDynamicCheckoutButton(event, root);
        if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;

        const form = button.closest('form') || root.querySelector('form[data-type="add-to-cart-form"]');
        const code = getThemeDiscountCode(form);
        const formData = getCartAddFormData(form, code);
        if (!code || !formData) return;

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        button.setAttribute('aria-disabled', 'true');
        button.disabled = true;

        try {
          await addProductToCart(formData);
          window.location.assign(buildDiscountCheckoutUrl(code));
        } catch (error) {
          showProductFormError(form, error);
          button.disabled = false;
          button.removeAttribute('aria-disabled');
        }
      },
      true
    );
  }

  function publishDiscount(root) {
    const form = root.querySelector('form[data-type="add-to-cart-form"]');
    const code = getThemeDiscountCode(form);
    const price = root.querySelector('[data-seed-discount-price]');
    const percent = Number.parseFloat(price?.dataset.seedDiscountPercent || '0');

    if (code && Number.isFinite(percent) && percent > 0) {
      root.dataset.seedDiscountCode = code;
      root.dataset.seedDiscountPercent = String(percent);
    } else {
      delete root.dataset.seedDiscountCode;
      delete root.dataset.seedDiscountPercent;
    }

    root.dispatchEvent(
      new CustomEvent('seed:discount-change', {
        bubbles: true,
        detail: { code, percent: Number.isFinite(percent) ? percent : 0 },
      })
    );
  }

  function initSeedDiscounts(source = document) {
    const scope = source?.target || source;
    syncProductForms(scope instanceof Element ? scope : document);

    const roots =
      scope instanceof Element
        ? scope.matches(PRODUCT_ROOT_SELECTOR)
          ? [scope]
          : Array.from(scope.querySelectorAll(PRODUCT_ROOT_SELECTOR))
        : Array.from(document.querySelectorAll(PRODUCT_ROOT_SELECTOR));

    roots.forEach((root) => {
      bindDynamicCheckout(root);
      publishDiscount(root);
    });
  }

  window.initSeedDiscounts = initSeedDiscounts;

  document.addEventListener('DOMContentLoaded', initSeedDiscounts);
  document.addEventListener('shopify:section:load', initSeedDiscounts);
  document.addEventListener('variant:change', initSeedDiscounts);
  document.addEventListener('product-info:loaded', initSeedDiscounts);
  window.addEventListener('load', initSeedDiscounts);

  if (document.readyState !== 'loading') initSeedDiscounts();

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, () => {
      window.setTimeout(initSeedDiscounts, 120);
    });
  }
})();
